import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { css, styled } from 'styled-components';
import { Box } from '@design-system/box';
import { Divider } from '@design-system/divider';
import { useTheme } from '@design-system/theme';
import { DropdownBase, } from './components/DropdownBase';
import { DropdownItem } from './components/DropdownItem';
import { StyledSimpleBar } from './components/StyledSimpleBar';
export const Dropdown = ({ buttonWrapperProps = {}, children, dataTestId = 'ds-dropdown', isDisabled = false, isFullWidth = false, items = [], maxHeight, onClickItem, position = 'left', title, wrapperStyles = {}, }) => {
    const theme = useTheme();
    const [focusedItem, setFocusedItem] = useState(null);
    useEffect(() => {
        setFocusedItem(null);
    }, [items]);
    const handleFocusItem = useCallback((item) => setFocusedItem(item), []);
    return (_jsx(DropdownBase, { buttonWrapperProps: buttonWrapperProps, dataTestId: dataTestId, isDisabled: isDisabled, isFullWidth: isFullWidth, maxHeight: maxHeight, position: position, renderContent: ({ handleClose, isOpen, wrapperItemsRef }) => (_jsx(DropdownContentWrapper, { ref: wrapperItemsRef, children: _jsx(StyledSimpleBar, { "$maxHeight": maxHeight, autoHide: true, dataTestId: "dropdown-items", children: _jsx("ul", { "aria-label": title, role: "list", tabIndex: -1, children: items.map((dropdownItem, index) => (_jsxs("li", { role: "listitem", children: [(dropdownItem === null || dropdownItem === void 0 ? void 0 : dropdownItem.withDivider) && _jsx(Divider, { my: 2 }), dropdownItem.render ? (dropdownItem.render({
                                isFocused: dropdownItem === focusedItem,
                                isOpen,
                                item: dropdownItem,
                                onClickItem,
                                onCloseDropdown: handleClose,
                                onFocusItem: handleFocusItem,
                                theme,
                            })) : (_jsx(DropdownItem, { isFocused: dropdownItem === focusedItem, isOpen: isOpen, item: dropdownItem, onClickItem: onClickItem, onCloseDropdown: handleClose, onFocusItem: handleFocusItem }))] }, index))) }) }) })), title: title, wrapperStyles: wrapperStyles, children: children }));
};
const DropdownContentWrapper = styled(Box).attrs(({ theme }) => ({
    bg: theme.input.bg,
    flexDirection: 'column',
    maxWidth: { _: 250, m: 'max-content' },
    mt: 2,
    py: 2,
})) `
  position: relative;
  width: max-content;

  button[type='button'] {
    width: 100% !important;
    // Overwrite the default of Button InnerWrapper
    & > div {
      justify-content: flex-start;
    }
  }

  ${({ theme }) => css `
    border-radius: 5px;
    box-shadow: ${theme.dropdown.boxShadow};
  `}
`;
//# sourceMappingURL=Dropdown.js.map